/*eslint-disable */
import { bus } from '@/main';
import toast from '@/services/toast';
export default {
  name: 'q-bank-delete-popup',
  components: {},
  props: ['removeQbankID'],
  data () {
    return {
      isSubmitted:false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    getCandidateListAgainMethod(){
      this.$store.dispatch('getQBankInfoAction')
    },
    confirmEvtDeletePopupMethod(){
        this.isSubmitted = true
        this.$store.dispatch('removeQBankInfoAction', {id:this.removeQbankID}).then((res) => {
          this.getCandidateListAgainMethod();
          this.closeEvtDeletePopupMethod();
          toast.success("The request has been successfully submitted");  
          this.isSubmitted = false
        }).catch((err) => {
          this.isSubmitted = false
        })
    },
    closeEvtDeletePopupMethod(){
      bus.$emit('removeQbankPopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
  }
}


